import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetFoldersByUserIdDto } from "../types/FolderPermission";

interface FolderState {
  folder: GetFoldersByUserIdDto | null;
  fromGrid: boolean;
}

const initialState: FolderState = {
  folder: null,
  fromGrid: false,
};

const folderSlice = createSlice({
  name: "folder",
  initialState,
  reducers: {
    setFolder: (
      state,
      action: PayloadAction<{ folderDetails: GetFoldersByUserIdDto; fromGrid: boolean }>
    ) => {
      state.folder = action.payload.folderDetails;
      state.fromGrid = action.payload.fromGrid;
    },
    clearFolder: (state) => {
      state.folder = null;
      state.fromGrid = false;
    },
  },
});

export const { setFolder, clearFolder } = folderSlice.actions;

export default folderSlice.reducer;
